/**
 * Money formatting. Every amount in this system is a whole number of shillings.
 *
 * There is no `parseFloat`, no division by 100 and no decimal anywhere in this file, because
 * there are no cents. A price is an integer; treating it as anything else is how a shilling gets
 * lost between the till and the ledger.
 */

const grouped = new Intl.NumberFormat('en-KE', { maximumFractionDigits: 0 });

/** `24500` → `"Ksh 24,500"`. The form used on screen. */
export function formatKes(shillings: number): string {
  return `Ksh ${grouped.format(shillings)}`;
}

/** `24500` → `"24,500"`. For a column that already has a currency header. */
export function formatAmount(shillings: number): string {
  return grouped.format(shillings);
}

/**
 * `"24,500"` or `"24500"` → `24500`. Returns null for anything that is not a whole,
 * non-negative amount — an empty box, a stray letter, a pasted decimal.
 */
export function parseKes(input: string): number | null {
  const cleaned = input.replace(/[\s,]/g, '');
  if (cleaned.length === 0 || !/^\d+$/.test(cleaned)) return null;

  const value = Number(cleaned);
  return Number.isSafeInteger(value) ? value : null;
}

/** Line total. Separate function so the multiplication happens in one place. */
export const lineTotal = (unitPriceKes: number, quantity: number): number => unitPriceKes * quantity;

export const sumKes = (amounts: readonly number[]): number =>
  amounts.reduce((total, amount) => total + amount, 0);
